module.exports = __webpack_public_path__ + "media/images/WFC_Portrait_Black-7b17f43e57624469fadf45f22a6d43fc.svg";